var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemindImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 390,
    height: 429,
    viewBox: "0 0 390 429",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1907_20618)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.375 227H128.938C150.166 227 167.375 244.209 167.375 265.438C167.375 286.666 150.166 303.875 128.938 303.875H116.772C109.166 303.875 103 297.709 103 290.103V250.75H120.5V286.375H128.938C140.501 286.375 149.875 277.001 149.875 265.438C149.875 253.874 140.501 244.5 128.938 244.5H112.375V227Z",
    fill: "url(#paint0_linear_1907_20618)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.75,
    cy: 235.75,
    r: 8.75,
    fill: "url(#paint1_linear_1907_20618)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.186 221.811C265.004 223.343 266.759 226.293 266.759 229.5V297C266.759 301.832 262.841 305.75 258.009 305.75C253.176 305.75 249.259 301.832 249.259 297V245.605L239.646 251.841C235.591 254.471 230.173 253.316 227.543 249.262C224.913 245.207 226.068 239.789 230.122 237.159L253.247 222.159C255.938 220.414 259.368 220.28 262.186 221.811Z",
    fill: "url(#paint2_linear_1907_20618)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_1907_20618",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243 244.902C243 249.735 239.082 253.652 234.25 253.652C229.418 253.652 225.5 249.735 225.5 244.902C225.5 240.07 229.418 236.152 234.25 236.152C239.082 236.152 243 240.07 243 244.902Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M243 244.902C243 249.735 239.082 253.652 234.25 253.652C229.418 253.652 225.5 249.735 225.5 244.902C225.5 240.07 229.418 236.152 234.25 236.152C239.082 236.152 243 240.07 243 244.902Z",
    fill: "url(#paint3_linear_1907_20618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5 244.902C225.5 240.07 229.418 236.152 234.25 236.152V271.152C248.747 271.152 260.5 259.4 260.5 244.902H225.5ZM234.25 236.152C239.082 236.152 243 240.07 243 244.902H208C208 259.4 219.753 271.152 234.25 271.152V236.152ZM243 244.902C243 249.735 239.082 253.652 234.25 253.652V218.652C219.753 218.652 208 230.405 208 244.902H243ZM234.25 253.652C229.418 253.652 225.5 249.735 225.5 244.902H260.5C260.5 230.405 248.747 218.652 234.25 218.652V253.652Z",
    fill: "url(#paint4_linear_1907_20618)",
    mask: "url(#path-4-inside-1_1907_20618)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.75 263.25C181.75 258.418 185.668 254.5 190.5 254.5H210.5C215.332 254.5 219.25 258.418 219.25 263.25C219.25 268.082 215.332 272 210.5 272H190.5C185.668 272 181.75 268.082 181.75 263.25Z",
    fill: "url(#paint5_linear_1907_20618)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.076 352.47C183.031 364.639 191.417 377.131 198.06 384.79C203.488 391.049 202.815 400.522 196.557 405.95C190.298 411.378 180.825 410.705 175.397 404.446C167.107 394.888 156.134 378.938 150.545 361.743C145.012 344.718 143.593 321.753 162.561 305.449C182.564 288.255 207.766 296.506 224.536 305.778C242.497 315.708 259.036 331.004 268.881 341.986C274.41 348.155 273.892 357.638 267.723 363.168C261.555 368.698 252.071 368.179 246.542 362.011C238.066 352.555 224.083 339.808 210.02 332.032C194.766 323.598 186.442 324.481 182.117 328.199C176.756 332.807 175.065 340.13 179.076 352.47Z",
    fill: "url(#paint6_linear_1907_20618)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.34 292.349C247.16 312.873 261.067 332.805 269.418 342.529C274.815 348.814 274.096 358.284 267.812 363.681C261.527 369.079 252.057 368.36 246.659 362.075C236.713 350.494 220.676 327.622 211.306 303.031C202.377 279.597 196.974 247.269 220.631 225.182C234.864 211.893 252.164 209.339 268.573 212.483C284.368 215.51 300.014 223.841 313.849 233.321C341.655 252.374 366.714 279.301 378.092 292.064C383.605 298.247 383.062 307.729 376.878 313.242C370.694 318.755 361.213 318.212 355.7 312.028C344.575 299.55 321.522 274.946 296.891 258.068C284.508 249.583 272.853 243.849 262.927 241.947C253.615 240.163 246.773 241.817 241.104 247.11C232.043 255.57 231.078 270.666 239.34 292.349Z",
    fill: "url(#paint7_linear_1907_20618)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.843 102.317C334.439 100.888 322.775 103.874 313.785 112.422C305.472 120.325 302.073 132.334 304.044 149.459C306.026 166.675 313.268 186.678 323.142 206.839C342.838 247.049 370.94 283.783 378.327 292.484C383.688 298.799 382.915 308.265 376.599 313.627C370.284 318.988 360.818 318.215 355.457 311.899C346.961 301.891 317.285 263.08 296.201 220.035C285.686 198.568 276.788 175.016 274.241 152.889C271.684 130.671 275.368 107.552 293.114 90.68C310.181 74.4529 331.456 70.4453 351.804 72.4633C371.823 74.4487 392.017 82.2961 409.449 91.1846C427.039 100.154 442.76 110.674 454.01 118.874C459.659 122.992 464.238 126.567 467.427 129.131C469.022 130.414 470.273 131.446 471.139 132.17C471.572 132.533 471.909 132.818 472.146 133.019C472.191 133.057 472.232 133.092 472.27 133.124C472.331 133.177 472.382 133.221 472.424 133.257L472.505 133.326L472.531 133.349L472.541 133.357C472.544 133.36 472.547 133.363 462.734 144.707L472.547 133.363C478.813 138.783 479.498 148.255 474.078 154.521C468.659 160.785 459.189 161.471 452.923 156.054C452.922 156.053 452.922 156.052 452.921 156.052L452.888 156.024C452.852 155.993 452.79 155.94 452.704 155.867C452.532 155.72 452.261 155.491 451.896 155.186C451.167 154.576 450.064 153.665 448.628 152.51C445.752 150.198 441.551 146.917 436.339 143.118C425.866 135.484 411.537 125.924 395.821 117.911C379.946 109.816 363.576 103.778 348.843 102.317Z",
    fill: "url(#paint8_linear_1907_20618)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1907_20618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.888 384.591C203.541 390.646 203.215 400.138 197.16 405.791C191.105 411.445 181.613 411.119 175.959 405.064C170.306 399.008 170.631 389.517 176.687 383.863C182.742 378.21 192.234 378.535 197.888 384.591Z",
    fill: "url(#paint9_linear_1907_20618)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1907_20618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.056 292.155C383.709 298.211 383.383 307.702 377.328 313.356C371.273 319.009 361.781 318.684 356.127 312.628C350.474 306.573 350.799 297.081 356.855 291.428C362.91 285.774 372.402 286.1 378.056 292.155Z",
    fill: "url(#paint10_linear_1907_20618)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6018 73.7017C-6.28032 76.7916 -28.9062 85.9727 -40.3083 91.9935L-53.443 67.1189C-40.0115 60.0266 -14.2544 49.5091 11.6688 45.8486C36.4413 42.3506 68.5951 44.3311 84.568 71.7613C94.1828 88.2728 92.8793 105.384 86.2628 120.48C79.8814 135.039 68.3926 148.342 56.1191 159.692C31.4585 182.495 -0.273826 200.909 -15.2329 209.165L-28.8259 184.538C-14.1803 176.455 15.0108 159.392 37.0215 139.039C48.0836 128.81 56.3676 118.615 60.4995 109.188C64.3962 100.297 64.3466 92.9349 60.2597 85.9164C53.7088 74.6666 38.6347 70.4493 15.6018 73.7017Z",
    fill: "url(#paint11_linear_1907_20618)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-17.7302 201.942C-39.6123 205.032 -62.2382 214.213 -73.6404 220.234L-86.775 195.359C-73.3435 188.267 -47.5865 177.749 -21.6632 174.089C3.10923 170.591 35.2631 172.571 51.236 200.002C60.8508 216.513 59.5473 233.625 52.9307 248.72C46.5493 263.279 35.0606 276.583 22.787 287.932C-1.87356 310.735 -33.6059 329.149 -48.5649 337.406L-62.158 312.779C-47.5123 304.695 -18.3213 287.632 3.68949 267.279C14.7516 257.05 23.0355 246.855 27.1674 237.428C31.0642 228.538 31.0146 221.175 26.9276 214.157C20.3767 202.907 5.30266 198.69 -17.7302 201.942Z",
    fill: "url(#paint12_linear_1907_20618)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1907_20618",
    x: 96.75,
    y: 214.5,
    width: 176.258,
    height: 97.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.524341 0 0 0 0 0.514708 0 0 0 0 0.635116 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1907_20618"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1907_20618",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1907_20618",
    x: 161.922,
    y: 365.828,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1907_20618"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1907_20618",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1907_20618",
    x: 342.09,
    y: 273.393,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1907_20618"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1907_20618",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1907_20618",
    x1: 136.75,
    y1: 308.875,
    x2: 75.6312,
    y2: 257.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D994"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1907_20618",
    x1: 111.75,
    y1: 227,
    x2: 111.75,
    y2: 244.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35D59B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E6AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1907_20618",
    x1: 271.124,
    y1: 303.875,
    x2: 208.979,
    y2: 283.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D994"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1907_20618",
    x1: 234.25,
    y1: 236.152,
    x2: 234.25,
    y2: 253.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35D59B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E6AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1907_20618",
    x1: 228.772,
    y1: 233.862,
    x2: 239.504,
    y2: 252.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D994"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1907_20618",
    x1: 178.625,
    y1: 254.25,
    x2: 236.249,
    y2: 274.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D994"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1907_20618",
    x1: 150.12,
    y1: 360.739,
    x2: 265.32,
    y2: 340.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D994",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1907_20618",
    x1: 170.649,
    y1: 241.229,
    x2: 368.057,
    y2: 286.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D994"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1907_20618",
    x1: 224.775,
    y1: 115.097,
    x2: 483.706,
    y2: 189.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D994"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1907_20618",
    x1: 176.687,
    y1: 383.863,
    x2: 197.16,
    y2: 405.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35D59B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E6AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1907_20618",
    x1: 356.855,
    y1: 291.428,
    x2: 377.328,
    y2: 313.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35D59B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E6AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1907_20618",
    x1: 78.5464,
    y1: 21.0074,
    x2: -9.92323,
    y2: 187.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D994"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1907_20618",
    x1: 45.2143,
    y1: 149.248,
    x2: -43.2553,
    y2: 315.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D994"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFEB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemindImage);
export default __webpack_public_path__ + "static/media/RemindImage.46a170c3925ba394292a41d1f467375b.svg";
export { ForwardRef as ReactComponent };